export const DEFAULT_HOME_SECTIONS = [
  { sectionKey: 'levelDashboard', sortOrder: 0 },
  { sectionKey: 'levelGoals', sortOrder: 10 },
  { sectionKey: 'teamspace', sortOrder: 20 },
  { sectionKey: 'tasks', sortOrder: 30 },
  { sectionKey: 'personalGoals', sortOrder: 40 },
];